module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("2L1uE"))).then(() => parcelRequire('ehoPl'));